export const resolveContactAvatar = (contact) => {
  try {
    const url = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof url === "string" && url.trim() !== "") {
      // ✅ Filtrar URLs inválidas que contêm "null" ou "undefined"
      const trimmedUrl = url.trim();
      if (trimmedUrl.includes('/null') || trimmedUrl.includes('/undefined') || 
          trimmedUrl === 'null' || trimmedUrl === 'undefined' ||
          trimmedUrl.startsWith('null') || trimmedUrl.startsWith('undefined')) {
        return "/nopicture.png";
      }
      return url;
    }
  } catch (e) {
    // noop
  }
  return "/nopicture.png";
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  return !(url.includes("nopicture.png") || url.endsWith("/nopicture.png"));
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};

export const resolveUserAvatar = (user, companyId, backendUrl) => {
  try {
    const profileImage = user?.profileImage;
    if (typeof profileImage === "string" && profileImage.trim() !== "") {
      const base =
        backendUrl ||
        process.env.REACT_APP_BACKEND_URL ||
        "";
      if (base) {
        return `${base.replace(/\/+$/, "")}/public/company${companyId}/user/${profileImage}`;
      }
    }
  } catch (_e) {
    // noop
  }
  return "/nopicture.png";
};

export const getMessageOperatorLabel = (message) => {
  if (message?.user?.name) return message.user.name;
  return null;
};

const sameUserId = (a, b) => {
  if (a == null || b == null) return false;
  return Number(a) === Number(b);
};

/**
 * Mensagens carregadas antes do upload da foto trazem user.profileImage null no JSON.
 * Para o operador logado, usa sempre o perfil atual (contexto / localStorage).
 */
export const mergeOperatorWithCurrentUser = (operator, message, currentUser) => {
  if (!operator || !currentUser?.id) return operator;

  const messageUserId = message?.userId ?? message?.user?.id ?? operator?.id;
  if (!sameUserId(messageUserId, currentUser.id)) return operator;

  const profileImage =
    currentUser.profileImage ||
    (typeof localStorage !== "undefined" ? localStorage.getItem("profileImage") : null) ||
    operator.profileImage;

  return {
    ...operator,
    name: currentUser.name || operator.name,
    profileImage: profileImage || null,
  };
};

/**
 * Operador CRM da mensagem outbound — só quando há evidência persistida.
 * Mensagens enviadas pelo celular (eco WhatsApp) ficam com userId null e retornam null.
 */
export const resolveMessageOperatorUser = (message, currentUser = null) => {
  if (!message?.fromMe) return null;

  let operator = null;

  if (message.userId != null) {
    operator = message.user
      ? { ...message.user, id: message.user.id ?? message.userId }
      : { id: message.userId, name: currentUser?.name ?? null, profileImage: null };
  } else if (message.user?.id != null) {
    operator = { ...message.user };
  } else {
    const body = message?.body;
    if (typeof body === "string") {
      const match = body.match(/^\*([^*\n]+):\*/);
      if (match?.[1]) {
        operator = {
          name: match[1].trim(),
          id: message.userId ?? message.user?.id,
          profileImage: message.user?.profileImage ?? null,
        };
      }
    }
  }

  if (!operator) return null;

  return mergeOperatorWithCurrentUser(operator, message, currentUser);
};

/**
 * Handler para suprimir erros 401 (Unauthorized) ao carregar imagens
 * Evita poluir o console com erros de autenticação em imagens
 */
export const handleImageError = (event) => {
  // Suprimir erros 401 (Unauthorized) silenciosamente
  // Esses erros são esperados quando o usuário não está autenticado
  const img = event.target;
  if (img && img.src) {
    // ✅ Verificar se a URL é inválida (contém null ou undefined)
    const src = img.src || '';
    if (src.includes('/null') || src.includes('/undefined') || 
        src === 'null' || src === 'undefined') {
      // URL inválida - substituir imediatamente sem tentar carregar
      img.onerror = null; // Prevenir loop infinito
      img.src = "/nopicture.png";
      return;
    }
    // Se a imagem falhou, substituir por imagem padrão sem gerar erro
    img.onerror = null; // Prevenir loop infinito
    img.src = "/nopicture.png";
  }
};

/**
 * Handler mais robusto que também previne o log no console
 */
export const handleImageErrorSilent = (event) => {
  const img = event.target;
  
  // Prevenir que o erro apareça no console
  event.stopPropagation();
  
  if (img) {
    // Substituir por imagem padrão
    img.onerror = null; // Prevenir loop infinito
    img.src = "/nopicture.png";
  }
};

